export default __webpack_public_path__ + "static/media/CelloTechReq.beeb6257.pdf";